import { Button } from "@zapier/design-system";

type NextButtonProps = { onPress: () => void; children: React.ReactNode };

export function NextButton({ onPress, children }: NextButtonProps) {
  return (
    <Button key="next" variant="primary" size="compact" onPress={onPress}>
      {children}
    </Button>
  );
}
